var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.65 1.5C11.65 1.08579 11.3142 0.75 10.9 0.75C10.4858 0.75 10.15 1.08579 10.15 1.5V3.68832C6.7449 4.03827 4.03831 6.74487 3.68835 10.15H1.5C1.08579 10.15 0.75 10.4858 0.75 10.9C0.75 11.3142 1.08579 11.65 1.5 11.65H3.68835C4.03831 15.0551 6.7449 17.7617 10.15 18.1117V20.5C10.15 20.9142 10.4858 21.25 10.9 21.25C11.3142 21.25 11.65 20.9142 11.65 20.5V18.1117C15.0551 17.7617 17.7617 15.0551 18.1117 11.65H20.5C20.9142 11.65 21.25 11.3142 21.25 10.9C21.25 10.4858 20.9142 10.15 20.5 10.15H18.1117C17.7617 6.74487 15.0551 4.03827 11.65 3.68832V1.5ZM5.15002 10.9C5.15002 7.72436 7.72439 5.14999 10.9 5.14999C14.0757 5.14999 16.65 7.72436 16.65 10.9C16.65 14.0756 14.0757 16.65 10.9 16.65C7.72439 16.65 5.15002 14.0756 5.15002 10.9ZM8.45001 10.9C8.45001 9.5469 9.54691 8.45 10.9 8.45C12.2531 8.45 13.35 9.5469 13.35 10.9C13.35 12.2531 12.2531 13.35 10.9 13.35C9.54691 13.35 8.45001 12.2531 8.45001 10.9ZM10.9 6.95C8.71849 6.95 6.95001 8.71847 6.95001 10.9C6.95001 13.0815 8.71849 14.85 10.9 14.85C13.0815 14.85 14.85 13.0815 14.85 10.9C14.85 8.71847 13.0815 6.95 10.9 6.95Z",
    fill: "#DC3558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationbook);
export default __webpack_public_path__ + "static/media/locationbook.9262f40637b5173b8d53063f1c53d16f.svg";
export { ForwardRef as ReactComponent };